<template lang="pug">
  div
    menu-dropdown-analytics(:title="$t('loyalty.analytics.regCllients')" linkTo="LoyaltyAnalytics")
    kpi-cards-clients(v-if="tipCons && fechaHasta && appProgram" :datagraf="datagraf" :tipCons="tipCons" :fechaHasta="fechaHasta" :appProgram="appProgram" @type-cons='typeChanging')
    ods-module
      div(slot='header').clearfix
        span {{ $t('loyalty.analytics.regCllients') }}
      div.text__item
        clients-table(v-if="showTable" :tipCons="tipCons", :fechaHasta="fechaHasta", :appProgram="appProgram")
</template>

<script>
import LoyaltyDropDownAnalytics from '@/components/loyalty/LoyaltyDropDownAnalytics'
import KpiCardsClients from '@/components/loyalty/Analytics/KpiCardsClients'
import ClientsTable from '@/components/loyalty/Analytics/ClientsTable'
import { mapGetters } from 'vuex'

export default {
  name: 'AnalyticsClients',
  components: {
    'menu-dropdown-analytics': LoyaltyDropDownAnalytics,
    'kpi-cards-clients': KpiCardsClients,
    'clients-table': ClientsTable
  },
  data () {
    return {
      fechaHasta: null,
      tipCons: null,
      appProgram: null,
      datagraf: null,
      params: null,
      showTable: false
    }
  },
  computed: {
    ...mapGetters(['getFechaHasta', 'getSelectedProgram', 'analyticsBussy', 'getCLTCGloading'])
  },
  methods: {
    typeChanging (data) {
      if ((data && data.tipCons !== this.tipCons) || (data && data.refresh)) {
        this.showTable = false
        // console.log('Listening typeChanging', data, this.tipCons)
        this.tipCons = data.tipCons
        setTimeout(() => {
          console.log('tipCons AC')
          this.showTable = true
        }, 800)
        // this.params = { ...this.params, tipCons: data }
        // console.log('this.params', this.params)
      }
    }
  },
  mounted () {
    // console.log(this.$route.params)
    this.datagraf = this.$route.params.datagraf
    this.fechaHasta = this.getFechaHasta
    this.appProgram = this.getSelectedProgram
    this.tipCons = 'T'
    // console.log(`this.getFechaHasta ${this.getFechaHasta} this.getSelectedProgram ${this.getSelectedProgram} this.tipCons ${this.tipCons}`)
    setTimeout(() => {
      console.log('mounted AC')
      this.showTable = true
    }, 800)
  },
  watch: {
    async getFechaHasta (newData, oldData) {
      if (newData) {
        this.showTable = false
        this.datagraf = null
        // console.log(`AC getFechaHasta ${newData} ${oldData}`)
        this.fechahasta = newData
        this.tipCons = 'T'
      }
    },
    async getSelectedProgram (newData, oldData) {
      if (newData) {
        this.showTable = false
        // console.log(`AC getSelectedProgram ${newData} ${oldData}`)
        this.appProgram = newData
      }
    }
  }
}
</script>
